import { IResearchWorkItem } from "features/Research/types";
import { apiClient } from "lib/apiClient";

export const claimResearchWorkItem = async (
  workItemId: string,
  version: number
): Promise<IResearchWorkItem> => {
  const response = await apiClient.post(
    `/research/work-items/${workItemId}/claim`,
    { version }
  );

  return response.data;
};
